// drawer/tabs/MitreTab.tsx
import {
  MitreAttacksComponent,
  MitreWeaknessesComponent,
  ThreatActorsComponent,
} from '@/sections/threats/drawer/components';
import type { EnrichedVulnerability } from '@/sections/threats/types';

interface MitreTabProps {
  threatIntel?: EnrichedVulnerability;
}

/**
 * MITRE tab content - ATT&CK techniques, CWE weaknesses, and threat actors
 */
export function MitreTab({ threatIntel }: MitreTabProps) {
  return (
    <>
      <ThreatActorsComponent threatIntel={threatIntel} />
      <MitreAttacksComponent threatIntel={threatIntel} />
      <MitreWeaknessesComponent threatIntel={threatIntel} />
    </>
  );
}
